export default {
    SCENARIO_IMPORT_REQUEST: 'SCENARIO_IMPORT_SCENARIO_IMPORT_REQUEST',
    SCENARIO_IMPORT_SUCCESS: 'SCENARIO_IMPORT_SCENARIO_IMPORT_SUCCESS',
    SCENARIO_USERS_REQUEST: 'SCENARIO_IMPORT_SCENARIO_USERS_REQUEST',
    SCENARIO_USERS_SUCCESS: 'SCENARIO_IMPORT_SCENARIO_USERS_SUCCESS',
    SCENARIO_ORGANIZATIONS_REQUEST: 'SCENARIO_IMPORT_SCENARIO_ORGANIZATIONS_REQUEST',
    SCENARIO_ORGANIZATIONS_SUCCESS: 'SCENARIO_IMPORT_SCENARIO_ORGANIZATIONS_SUCCESS',
    DISPOSE: 'SCENARIO_IMPORT_DISPOSE_STORE',
};
